import zh_CN from '../../date-picker/locale/zh_CN';
export default zh_CN;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/calendar/locale/zh_CN.js
// module id = 283
// module chunks = 0